import { Component, Input } from '@angular/core';
import { MESES } from "../../../util/format";
import { Solicitacao } from "../../../model/solicitacao";
import { RespostaUsuarioCns } from "../../../model/usuario-cns";
import { Estabelecimento } from "../../../model/estabelecimento";
import { cnpj, cns, cpf, cep } from "../../../util/format";

@Component({
  selector: 'app-termo-cns',
  templateUrl: './termo-cns.component.html',
})
export class TermoCnsComponent {

  @Input() solicitacao: Solicitacao = new Solicitacao();
  @Input() responsavel: RespostaUsuarioCns = new RespostaUsuarioCns();
  @Input() estabelecimento: Estabelecimento = new Estabelecimento();

  dia: string;
  mes: string;
  ano: string;
  nomeGestor: string;
  cpfGestor: string;
  telefoneGestor: string;
  emailGestor: string;
  nomeCessionario: string;
  cnpjCessionario: string;
  enderecoCessionario: string;
  cepCessionario: string;
  cnpj = cnpj;
  cns = cns;
  cpf = cpf;
  cep = cep;

  constructor() {
    const date = new Date();
    this.dia = date.getDate().toString();
    this.mes = MESES[ date.getMonth() ];
    this.ano = date.getFullYear().toString();
  }

  ngAfterViewInit() {
    this.nomeGestor = this.responsavel.usuarioSUS.nome;
    this.cpfGestor = this.responsavel.usuarioSUS.numeroCPF;
    this.telefoneGestor = this.responsavel.usuarioSUS.numTelefone.toString();
    this.emailGestor = this.responsavel.usuarioSUS.email;
    this.nomeCessionario = this.estabelecimento.nomeEmpresarial;
    this.cnpjCessionario = this.estabelecimento.numeroCNPJ;
    this.enderecoCessionario = this.estabelecimento.descricaoEndereco;
    this.cepCessionario = this.estabelecimento.cep;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/termo/cns/termo-cns.component.ts